// extracted by mini-css-extract-plugin
export default {"container":"sidebar_container__RDvAQ","iconsignout":"sidebar_iconsignout__QLgXU"};